import { ITeamMember, ITeamMemberSocialLink } from '@/sanity/lib/definitions';
import { resolveI18nRichtext, resolveI18nText } from '@/sanity/globals/I18n';
import { GroqImage } from '@/helpers/Image';
import { PortableText } from 'next-sanity';
import { richTextComponent } from '@/sanity/sanityPortableText';
import Link from 'next/link';

function IconWorld() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-[3rem] w-[3rem] shrink-0"
    >
      <path
        d="M3.59961 9H20.3996M3.59961 15H20.3996M11.4997 3C9.81501 5.69961 8.92188 8.81787 8.92188 12C8.92188 15.1821 9.81501 18.3004 11.4997 21M12.5 3C14.1847 5.69961 15.0778 8.81787 15.0778 12C15.0778 15.1821 14.1847 18.3004 12.5 21M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconYoutube() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-[3rem] w-[3rem] shrink-0"
    >
      <path
        d="M2 8C2 6.93913 2.42143 5.92172 3.17157 5.17157C3.92172 4.42143 4.93913 4 6 4H18C19.0609 4 20.0783 4.42143 20.8284 5.17157C21.5786 5.92172 22 6.93913 22 8V16C22 17.0609 21.5786 18.0783 20.8284 18.8284C20.0783 19.5786 19.0609 20 18 20H6C4.93913 20 3.92172 19.5786 3.17157 18.8284C2.42143 18.0783 2 17.0609 2 16V8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9L15 12L10 15V9Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconInstagram() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-[3rem] w-[3rem] shrink-0"
    >
      <path
        d="M16.5 7.5V7.51M4 8C4 6.93913 4.42143 5.92172 5.17157 5.17157C5.92172 4.42143 6.93913 4 8 4H16C17.0609 4 18.0783 4.42143 18.8284 5.17157C19.5786 5.92172 20 6.93913 20 8V16C20 17.0609 19.5786 18.0783 18.8284 18.8284C18.0783 19.5786 17.0609 20 16 20H8C6.93913 20 5.92172 19.5786 5.17157 18.8284C4.42143 18.0783 4 17.0609 4 16V8ZM9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconLinkedin() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-[3rem] w-[3rem] shrink-0"
    >
      <path
        d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 11V16M8 8V8.01M12 16V13C12 11.8954 12.8954 11 14 11C15.1046 11 16 11.8954 16 13V16M12 11V16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconTwitter() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-[3rem] w-[3rem] shrink-0"
    >
      <path
        d="M4 4L10.5 12.5L4 20H6L11.5 13.75L16.5 20H20.5L13.5 11L19.5 4H17.5L12.5 9.75L8 4H4Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SocialIcon({
  platform,
}: {
  platform: ITeamMemberSocialLink['platform'];
}) {
  switch (platform) {
    case 'website':
      return <IconWorld />;
    case 'youtube':
      return <IconYoutube />;
    case 'instagram':
      return <IconInstagram />;
    case 'linkedin':
      return <IconLinkedin />;
    case 'twitter':
      return <IconTwitter />;
    default:
      return null;
  }
}

interface TeamMemberProps {
  member: ITeamMember;
  language?: string;
}

export default function TeamMember({ member, language }: TeamMemberProps) {
  const quote = resolveI18nRichtext(member.quote, member.i18n, language);
  const role = resolveI18nText(member.role, member.roleI18n, language);
  const youtubeSubscribers = resolveI18nText(member.youtubeSubscribers, member.youtubeSubscribersI18n, language);
  return (
    <article className="flex lg:w-[55rem] w-[48rem] flex-col h-full">
      {/* Photo */}
      <div className="relative aspect-[439/498] w-full overflow-hidden bg-[#e2f3ef]">
        {member.image && (
          <GroqImage
            src={member.image.src}
            alt={member.name}
            width={member.image.width}
            height={member.image.height}
            className="!h-full !w-full object-cover"
          />
        )}

        {/* YouTube subscribers badge */}
        {youtubeSubscribers && (
          <div className="absolute bottom-[4rem] left-[2.75rem] flex items-center gap-[1.625rem] border border-[rgba(0,0,0,0.1)] bg-[#003828] px-[1.125rem] py-[1rem]">
            <svg
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="h-[2.5rem] w-[2.5rem] shrink-0"
            >
              <rect width="20" height="20" fill="white" fillOpacity="0.2" />
              <path
                d="M5.18601 11.1589L8.11677 14.0755L14.8156 7.40885"
                stroke="white"
                strokeWidth="1.5"
              />
            </svg>
            <p className="mb-0 whitespace-nowrap font-geist-mono text-[1.625rem] font-semibold uppercase leading-[1.33] text-white">
              {youtubeSubscribers}
            </p>
          </div>
        )}
      </div>

      {/* Info */}
      <div className="flex flex-1 flex-col gap-[1.12rem] border border-black/10 bg-white p-[2.62rem] lg:px-[5.5rem] lg:pb-[4.75rem] lg:pt-[4.25rem]">
        <h3 className="mb-0 font-blacker text-[3.5rem] italic leading-[1.12] tracking-[-0.105rem] text-black">
          {member.name}
        </h3>

        <p className="mb-0 font-geist-mono text-[1.5rem] font-medium uppercase leading-[1.5] text-black/40">
          {role}
        </p>

        {quote && (
          <div className="richtext richtext-start prose-p:mb-0 prose-p:text-[2rem] prose-p:leading-[1.5] prose-p:tracking-[-0.1rem] prose-p:text-black/80">
            <PortableText value={quote} components={richTextComponent} />
          </div>
        )}

        {!!member.socialLinks?.length && (
          <div className="mt-auto flex items-center gap-[2rem]">
            {member.socialLinks.map((link) => (
              <Link
                key={link._key}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-black transition-opacity hover:opacity-50"
              >
                <SocialIcon platform={link.platform} />
              </Link>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}
